import React from "react";

import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';



const HubspotContactForm = () => {
    // eslint-disable-next-line no-unused-vars
    const { loaded, error, formCreated } = useHubspotForm({
        region: "na1",
                portalId: "20066818",
                formId: "f70bcf79-a933-40cb-b30d-7ed79ae6e222",
                target: "#contact-form"
    });

    

    return (
        <div>
            <div id="contact-form"></div>
        </div>
    )
}


// class HubspotContactForm extends React.Component {
//     componentDidMount() {
//         const script = document.createElement('script');
//       script.src = 'https://js.hsforms.net/forms/v2.js';
//       document.body.appendChild(script);
      
//       script.addEventListener('load', () => {
//           if(window.hbspt) {
//             window.hbspt.forms.create({
//                 region: "na1",
//                 portalId: "20066818",
//                 formId: "f70bcf79-a933-40cb-b30d-7ed79ae6e222",
//                 target: "#contact-form"
//           })
//         }
//       });
//     }

    
//       render() {
//         return (
//             <div>
//               <div id="contact-form"></div>
//             </div>
//       );
//     }
//   }


export default HubspotContactForm;